import { ResourcesConfig } from "aws-amplify";

const config: ResourcesConfig = {
	Auth: {
		Cognito: {
			userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
			userPoolId: import.meta.env.VITE_USER_POOL_ID,
			identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
			loginWith: {
				oauth: {
					domain: import.meta.env.VITE_OAUTH_DOMAIN,
					scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
					redirectSignIn: ['http://localhost:5173/callback', 'https://xnav.studio/callback', 'https://www.xnav.studio/callback'],
					redirectSignOut: ['http://localhost:5173/logout', 'https://xnav.studio/logout', 'https://www.xnav.studio/logout'],
					responseType: 'code',
				},
				username: false,
				email: true,
				phone: false
			}
		}
	}
}

export default config

